import { LANDING_AMPLITUDE_EVENTS, LOCAL_STORAGE_KEYS } from '@/constants';
import benefit from '@/public/images/remove-bg/benefit.webp';
import howWork from '@/public/images/remove-bg/howToRemove.webp';
import img1 from '@/public/images/remove-bg/remove_bg1.webp';
import img2 from '@/public/images/remove-bg/remove_bg2.webp';
import whyLift from '@/public/images/remove-bg/removeTool.webp';
import { type LandingConfigItem } from '../../types';
import { exploreConfig } from './exploreConfig';
import { tryLiftConfig } from './tryLiftConfig';

export const landingBackgroundRemoverConfig: LandingConfigItem = {
	id: 'bgRemover',
	translationLocale: 'background-remover',
	withDropZone: true,
	hero: {
		type: 'default',
		title: 'heroData.title',
		description: 'heroData.subtitle',
		buttonText: 'heroData.buttonText',
		data: {
			dropzoneTitle: 'heroData.dropzoneTitle',
			format: 'sharedLandingData:format',
			size: 'sharedLandingData:size',
		},
		images: [
			{
				id: 'left',
				image: img1,
				title: 'heroData.imageTitle1',
				alt: 'heroData.imageAlt1',
			},
			{
				id: 'right',
				image: img2,
				title: 'heroData.imageTitle2',
				alt: 'heroData.imageAlt2',
			},
		],
	},
	howItWork: {
		title: 'howItWorkData.mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '🖼',
				title: 'howItWorkData.title1',
				subtitle: 'howItWorkData.subtitle1',
			},
			{
				icon: '✨',
				title: 'howItWorkData.title2',
				subtitle: 'howItWorkData.subtitle2',
			},
			{
				icon: '💁‍♀️',
				title: 'howItWorkData.title3',
				subtitle: 'howItWorkData.subtitle3',
			},
			{
				icon: '🤘',
				title: 'howItWorkData.title4',
				subtitle: 'howItWorkData.subtitle4',
			},
		],
		images: [
			{
				image: howWork,
				title: 'howItWorkData.imageTitle',
				alt: 'howItWorkData.imageAlt',
			},
		],
	},
	benefits: {
		title: 'benefitData.mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '🔹',
				subtitle: 'benefitData.subtitle1',
			},
			{
				icon: '🔹',
				title: '',
				subtitle: 'benefitData.subtitle2',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData.subtitle3',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData.subtitle4',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData.subtitle5',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData.subtitle6',
			},
		],
		images: [
			{
				image: benefit,
				title: 'benefitData.imageTitle',
				alt: 'benefitData.imageAlt',
			},
		],
	},
	faq: {
		title: 'faqData.mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				title: 'faqData.title1',
				subtitle: 'faqData.subtitle1',
			},
			{
				title: 'faqData.title2',
				subtitle: 'faqData.subtitle2',
			},
			{
				title: 'faqData.title3',
				subtitle: 'faqData.subtitle3',
			},
			{
				title: 'faqData.title4',
				subtitle: 'faqData.subtitle4',
			},
		],
	},
	whyLift: {
		title: 'whyUseData.mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '✅',
				title: 'whyUseData.title1',
				subtitle: 'whyUseData.subtitle1',
			},
			{
				icon: '✅',
				title: 'whyUseData.title2',
				subtitle: 'whyUseData.subtitle2',
			},
			{
				icon: '✅',
				title: 'whyUseData.title3',
				subtitle: 'whyUseData.subtitle3',
			},
			{
				icon: '✅',
				title: 'whyUseData.title4',
				subtitle: 'whyUseData.subtitle4',
			},
		],
		images: [
			{
				image: whyLift,
				title: 'whyUseData.imageTitle',
				alt: 'whyUseData.imageAlt',
			},
		],
	},
	explore: {
		...exploreConfig,
	},
	tryLift: {
		...tryLiftConfig,
	},
	analytics: {
		scrolledPercentName: LOCAL_STORAGE_KEYS.BACKGROUND_REMOVER_SCROLLED_POINTS,
		eventPropertyType: LANDING_AMPLITUDE_EVENTS.IMAGE_ENHANCER,
		galleryContext: LANDING_AMPLITUDE_EVENTS.BACKGROUND_REMOVER_LANDING,
	},
};
